export function scrollTo (selector, typeAnimation = 'smooth') {
    const scrollElement = document.querySelector(`${selector}`).getBoundingClientRect().top + window.scrollY;
    window.scroll({
        top: scrollElement,
        behavior: typeAnimation
    })
}
